const Payment = () => {
  return <h1 className="text-lg font-bold text-gray-600 mb-1">Payment</h1>;
};

export default Payment;
